module.exports = __webpack_public_path__ + "img/c4d9247.jpg";